/**
 * Versand oder Abholung — Bestaetigung vor dem ersten Gebot + Umschalter
 *
 * 1. Bid-Buttons abfangen (wie terms-acceptance.js, laeuft danach): Ist die Wahl fuer
 *    das Projekt noch nicht bestaetigt, erscheint ein Modal mit Versand (vorausgewaehlt)
 *    und Abholung. Nach dem Speichern wird der urspruengliche Klick erneut ausgeloest.
 * 2. Umschalter [data-bsv-choose] (Projekt-Sidebar, Box ueber dem Losraster, Losseite,
 *    Auktions-Zentrale) speichern die Wahl direkt per AJAX.
 * 3. Das Pop-up "Versandkosten" kommt serverseitig (Brandner_Shipping::print_cost_dialog)
 *    und funktioniert auch ohne dieses Skript.
 *
 * @package Brandner_Custom
 * @since 2.0.0
 */

(function($) {
    'use strict';

    var config = window.brandnerShipping || {};
    if (!config.ajaxUrl) {
        return; // nicht geladen
    }
    // Auf Konto-Seiten laufen auction-loop- und myaccount-Bundle zusammen — nur einmal initialisieren
    if (window.__brandnerShippingInit) {
        return;
    }
    window.__brandnerShippingInit = true;

    // Gleiche Bietwege wie terms-acceptance.js (Losseite, Loskarten, mobile Sticky-Leiste + Gebots-Sheet)
    var bidButtonSelectors = [
        '#placebidbutton',
        '#placebidbutton_direct',
        '.place-bid-button',
        'button[name="uwa-place-bid"]',
        '.bid-submit-btn',
        '.sticky-bar-bid',
        '#single-bid-submit'
    ].join(', ');

    // Status je Projekt: undefined = ungeprueft, true = Bestaetigung noetig, false = erledigt
    var statusByProject = {};
    var dataByProject = {};
    // Produkt -> Projekt (aus AJAX-Antwort)
    var projectByProduct = {};

    var pendingBidButton = null;
    var isOpen = false;
    var currentData = null;
    var selected = '';

    function t(key, fallback) {
        return (config.i18n && config.i18n[key]) || fallback;
    }

    function escapeHtml(s) {
        return String(s || '').replace(/[&<>"']/g, function(c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var ICON_PIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z"/><circle cx="12" cy="10" r="3"/></svg>';

    function canShip(data) {
        return !!(data && data.country_supported && data.address_html);
    }

    // ------------------------------------------------------------------
    // Modal (vor dem ersten Gebot bzw. "aendern")
    // ------------------------------------------------------------------

    function createModal() {
        if ($('#brandner-shipping-modal').length) return;

        var html = '' +
            '<div class="brandner-ship-overlay" id="brandner-shipping-modal" role="dialog" aria-modal="true" aria-labelledby="brandner-ship-title">' +
            '  <div class="brandner-ship-modal">' +
            '    <div class="brandner-ship-header">' +
            '      <h3 class="brandner-ship-title" id="brandner-ship-title">' + escapeHtml(t('title', 'Versand oder Abholung?')) + '</h3>' +
            '      <button type="button" class="brandner-ship-close" id="brandner-ship-close" aria-label="Schließen">' +
            '        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
            '      </button>' +
            '    </div>' +
            '    <div class="brandner-ship-body" id="brandner-ship-body"></div>' +
            '    <div class="brandner-ship-footer">' +
            '      <div class="brandner-ship-error" id="brandner-ship-error" role="alert"></div>' +
            '      <button type="button" class="brandner-ship-confirm" id="brandner-ship-confirm" disabled>' +
            '        <span id="brandner-ship-confirm-text">' + escapeHtml(t('confirm', 'Auswahl bestätigen und bieten')) + '</span>' +
            '      </button>' +
            '    </div>' +
            '  </div>' +
            '</div>';

        $('body').append(html);

        $('#brandner-ship-close').on('click', closeModal);
        $('#brandner-shipping-modal').on('click', function(e) {
            if ($(e.target).is('#brandner-shipping-modal')) closeModal();
        });
        $(document).on('keydown.brandnerShip', function(e) {
            if (e.key === 'Escape' && isOpen) closeModal();
        });
        $('#brandner-ship-body').on('click', '.brandner-ship-option:not(.is-disabled)', function() {
            selectOption($(this).data('choice'));
        });
        $('#brandner-ship-body').on('change', 'input[name="brandner_ship_choice"]', function() {
            selectOption($(this).val());
        });
        $('#brandner-ship-body').on('click', '.brandner-ship-details-toggle', function(e) {
            e.preventDefault();
            var $d = $('#brandner-ship-body .brandner-ship-details');
            $d.toggleClass('is-open');
            $(this).attr('aria-expanded', $d.hasClass('is-open') ? 'true' : 'false');
        });
        $('#brandner-ship-confirm').on('click', handleConfirm);
    }

    function renderBody(data) {
        var shippingDisabled = !canShip(data);
        var pre = data.choice || data.effective_choice || (shippingDisabled ? 'pickup' : 'shipping');
        if (pre === 'shipping' && shippingDisabled) pre = 'pickup';
        var html = '';

        html += '<p class="brandner-ship-intro">' + escapeHtml(t('intro', '')) + '</p>';
        html += '<p class="brandner-ship-change-note">' + escapeHtml(t('changeNote', '')) + '</p>';
        if (data.project_name) {
            html += '<p class="brandner-ship-project">' + escapeHtml(data.project_name) + '</p>';
        }

        // Option Versand
        html += '<label class="brandner-ship-option' + (shippingDisabled ? ' is-disabled' : '') + (pre === 'shipping' ? ' is-selected' : '') + '" data-choice="shipping">';
        html += '  <input type="radio" name="brandner_ship_choice" value="shipping"' + (shippingDisabled ? ' disabled' : '') + (pre === 'shipping' ? ' checked' : '') + '>';
        html += '  <span class="brandner-ship-option__icon" aria-hidden="true">' + ICON_TRUCK + '</span>';
        html += '  <span class="brandner-ship-option__body">';
        html += '    <span class="brandner-ship-option__title">' + escapeHtml(t('shipping', 'Versand mit DHL')) + '</span>';
        if (data.summary) {
            html += '    <span class="brandner-ship-option__price">' + escapeHtml(data.summary) + '</span>';
        }
        if (data.address_html) {
            html += '    <span class="brandner-ship-option__address">' + data.address_html + '</span>';
        } else {
            html += '    <span class="brandner-ship-option__address brandner-ship-option__address--missing">' + escapeHtml(t('noAddress', 'Keine Lieferadresse hinterlegt.')) + '</span>';
        }
        if (data.address_html && !data.country_supported) {
            html += '    <span class="brandner-ship-option__warn">' + escapeHtml(t('notSupported', '')) + '</span>';
        }
        if (data.edit_address_url) {
            html += '    <a class="brandner-ship-option__link" href="' + escapeHtml(data.edit_address_url) + '" target="_blank" rel="noopener">' + escapeHtml(t('change', 'Adresse ändern')) + ' &rarr;</a>';
        }
        html += '  </span>';
        html += '</label>';

        // Option Abholung
        html += '<label class="brandner-ship-option' + (pre === 'pickup' ? ' is-selected' : '') + '" data-choice="pickup">';
        html += '  <input type="radio" name="brandner_ship_choice" value="pickup"' + (pre === 'pickup' ? ' checked' : '') + '>';
        html += '  <span class="brandner-ship-option__icon" aria-hidden="true">' + ICON_PIN + '</span>';
        html += '  <span class="brandner-ship-option__body">';
        html += '    <span class="brandner-ship-option__title">' + escapeHtml(t('pickup', 'Abholung vor Ort')) + (data.pickup_place ? ' in ' + escapeHtml(data.pickup_place) : '') + '</span>';
        if (data.pickup_address) {
            html += '    <span class="brandner-ship-option__address">' + escapeHtml(data.pickup_address).replace(/\n/g, '<br>') + '</span>';
        }
        html += '    <span class="brandner-ship-option__note">' + escapeHtml(t('pickupNote', '')) + '</span>';
        html += '  </span>';
        html += '</label>';

        // Versandkosten im Detail (aufklappbar)
        if (data.overview_html) {
            html += '<button type="button" class="brandner-ship-details-toggle" aria-expanded="false">' + escapeHtml(t('showCosts', 'Versandkosten im Detail')) + '</button>';
            html += '<div class="brandner-ship-details">' + data.overview_html + '</div>';
        }

        return { html: html, preselected: pre };
    }

    function openModal(data, withBid) {
        createModal();
        currentData = data;
        isOpen = true;

        var body = renderBody(data);
        selected = body.preselected;
        $('#brandner-ship-body').html(body.html);
        $('#brandner-ship-error').text('').hide();
        $('#brandner-ship-confirm-text').text(withBid ? t('confirm', 'Auswahl bestätigen und bieten') : t('save', 'Auswahl speichern'));
        $('#brandner-ship-confirm').prop('disabled', selected === '');

        $('body').addClass('brandner-ship-modal-open');
        $('#brandner-shipping-modal').addClass('active');
    }

    function closeModal() {
        isOpen = false;
        $('body').removeClass('brandner-ship-modal-open');
        $('#brandner-shipping-modal').removeClass('active');
        pendingBidButton = null;
    }

    function selectOption(choice) {
        if (choice === 'shipping' && !canShip(currentData)) {
            return;
        }
        selected = choice;
        $('#brandner-ship-body .brandner-ship-option').removeClass('is-selected');
        $('#brandner-ship-body .brandner-ship-option[data-choice="' + choice + '"]').addClass('is-selected')
            .find('input[type="radio"]').prop('checked', true);
        $('#brandner-ship-confirm').prop('disabled', false);
        $('#brandner-ship-error').text('').hide();
    }

    function saveChoice(projectId, choice, done, fail) {
        $.ajax({
            url: config.ajaxUrl,
            type: 'POST',
            data: {
                action: 'brandner_shipping_choose',
                nonce: config.nonce,
                project_id: projectId,
                choice: choice
            },
            success: function(response) {
                if (response && response.success) {
                    statusByProject[projectId] = false;
                    if (dataByProject[projectId]) {
                        dataByProject[projectId].choice = choice;
                    }
                    updateToggles(projectId, choice, response.data && response.data.message);
                    done && done(response.data || {});
                } else {
                    fail && fail((response && response.data) || {});
                }
            },
            error: function() {
                fail && fail({ message: 'Netzwerkfehler. Bitte versuchen Sie es erneut.' });
            }
        });
    }

    function handleConfirm() {
        if (!selected || !currentData) return;
        var $btn = $('#brandner-ship-confirm');
        var original = $('#brandner-ship-confirm-text').text();
        $btn.prop('disabled', true);
        $('#brandner-ship-confirm-text').text(t('saving', 'Wird gespeichert …'));

        saveChoice(currentData.project_id, selected, function() {
            var btn = pendingBidButton;
            closeModal();
            if (btn) {
                triggerOriginalBid(btn);
            }
        }, function(err) {
            $('#brandner-ship-error').text(err.message || t('error', 'Fehler beim Speichern')).show();
            $btn.prop('disabled', false);
            $('#brandner-ship-confirm-text').text(original);
        });
    }

    // ------------------------------------------------------------------
    // Umschalter Versand | Abholung
    // ------------------------------------------------------------------

    /**
     * Alle Umschalter eines Projekts auf der Seite aktualisieren.
     */
    function updateToggles(projectId, choice, message) {
        $('.bsv-choice[data-project-id="' + projectId + '"]').each(function() {
            var $c = $(this);
            $c.attr('data-choice', choice).attr('data-confirmed', '1');
            $c.find('.bsv-choice__hint').remove();
            $c.find('.bsv-choice__opt').each(function() {
                var on = $(this).data('bsv-choose') === choice;
                $(this).toggleClass('is-active', on).attr('aria-pressed', on ? 'true' : 'false');
            });
            if (message) {
                $c.find('.bsv-choice__msg').removeClass('is-error').text(message);
            }
        });
    }

    /**
     * Bestaetigungs-Pop-up vor jeder Umstellung (Lucas 28.10.2026).
     */
    var confirmDlg = null;
    var confirmYes = null;

    function askConfirm(choice, keep, place, onYes) {
        if (!confirmDlg) {
            confirmDlg = document.createElement('dialog');
            confirmDlg.className = 'bsv-dialog bsv-confirm';
            confirmDlg.setAttribute('aria-labelledby', 'bsv-confirm-title');
            confirmDlg.innerHTML =
                '<div class="bsv-dialog__inner">' +
                '  <div class="bsv-dialog__head"><h2 class="bsv-dialog__title" id="bsv-confirm-title"></h2></div>' +
                '  <p class="bsv-confirm__text"></p>' +
                '  <p class="bsv-confirm__note"></p>' +
                '  <div class="bsv-confirm__actions">' +
                '    <button type="button" class="bsv-confirm__btn" data-bsv-confirm="no"></button>' +
                '    <button type="button" class="bsv-confirm__btn bsv-confirm__btn--yes" data-bsv-confirm="yes"></button>' +
                '  </div>' +
                '</div>';
            document.body.appendChild(confirmDlg);
            confirmDlg.addEventListener('click', function(e) {
                var b = e.target.closest('[data-bsv-confirm]');
                if (e.target === confirmDlg || b) {
                    var yes = b && b.getAttribute('data-bsv-confirm') === 'yes';
                    closeConfirm();
                    if (yes && confirmYes) confirmYes();
                }
            });
            confirmDlg.addEventListener('close', function() {
                document.documentElement.classList.remove('bsv-dialog-open');
            });
        }
        var title = keep ? t('confirmTitleKeep', 'Versand bestätigen?')
            : (choice === 'shipping' ? t('confirmTitleShipping', 'Auf Versand umstellen?') : t('confirmTitlePickup', 'Auf Abholung umstellen?'));
        var text = choice === 'shipping'
            ? t('confirmShipping', '')
            : t('confirmPickup', '').replace('%s', place ? ' in ' + place : '');
        confirmDlg.querySelector('.bsv-dialog__title').textContent = title;
        confirmDlg.querySelector('.bsv-confirm__text').textContent = text;
        confirmDlg.querySelector('.bsv-confirm__note').textContent = t('confirmNote', '');
        confirmDlg.querySelector('[data-bsv-confirm="no"]').textContent = t('confirmCancel', 'Abbrechen');
        confirmDlg.querySelector('[data-bsv-confirm="yes"]').textContent = keep ? t('confirmYesKeep', 'Ja, bestätigen') : t('confirmYes', 'Ja, ändern');
        confirmYes = onYes;
        if (typeof confirmDlg.showModal === 'function') { confirmDlg.showModal(); } else { confirmDlg.setAttribute('open', ''); }
        document.documentElement.classList.add('bsv-dialog-open');
    }

    function closeConfirm() {
        if (!confirmDlg) return;
        if (typeof confirmDlg.close === 'function' && confirmDlg.open) { confirmDlg.close(); } else { confirmDlg.removeAttribute('open'); }
        document.documentElement.classList.remove('bsv-dialog-open');
    }

    function bindToggles() {
        $(document).on('click', '[data-bsv-choose]', function(e) {
            e.preventDefault();
            var $opt = $(this);
            var $c = $opt.closest('.bsv-choice');
            var projectId = $c.data('project-id');
            var choice = $opt.data('bsv-choose');
            if (!projectId || !choice || $opt.prop('disabled') || $c.attr('data-locked') === '1') return;
            if ($opt.hasClass('is-active') && $c.attr('data-confirmed') === '1') return;
            var keep = $opt.hasClass('is-active'); // vorausgewaehlte Wahl nur bestaetigen
            askConfirm(choice, keep, $c.attr('data-pickup-place') || '', function() {
                saveToggle($c, projectId, choice);
            });
        });
    }

    function saveToggle($c, projectId, choice) {
        var $all = $('.bsv-choice[data-project-id="' + projectId + '"]');
        $all.addClass('is-saving').find('.bsv-choice__msg').removeClass('is-error').text(t('saving', 'Wird gespeichert …'));
        saveChoice(projectId, choice, function() {
            $all.removeClass('is-saving');
        }, function(err) {
            $all.removeClass('is-saving');
            var $msg = $c.find('.bsv-choice__msg').addClass('is-error').text(err.message || t('error', 'Das hat nicht geklappt.'));
            if (err.url) {
                $msg.append(' <a href="' + escapeHtml(err.url) + '">Adresse hinterlegen</a>');
            }
            if (err.code === 'ended') {
                $all.attr('data-locked', '1').find('.bsv-choice__opt').prop('disabled', true);
            }
        });
    }

    /**
     * Rueckfallnetz: Lehnt der Server ein Gebot ab, weil die Wahl fehlt (Bietweg ohne
     * Abfang im Frontend), das Modal fuer dieses Projekt oeffnen.
     */
    function bindBidFallback() {
        $(document).ajaxComplete(function(e, xhr, settings) {
            var data = settings && typeof settings.data === 'string' ? settings.data : '';
            if (data.indexOf('uwa_ajax_placed_bid') === -1) return;
            var res = xhr && xhr.responseJSON;
            if (!res && xhr && xhr.responseText) {
                try { res = JSON.parse(xhr.responseText); } catch (err) { res = null; }
            }
            if (!res || !res.shipping_choice_required || !res.project_id || isOpen) return;
            pendingBidButton = null;
            fetchStatus({ project_id: res.project_id }, function(st) {
                if (!st.project_id) return;
                dataByProject[st.project_id] = st;
                statusByProject[st.project_id] = !!st.required;
                if (st.required) openModal(st, false);
            });
        });
    }

    function triggerOriginalBid(button) {
        setTimeout(function() {
            $(button).data('shipping-chosen', true);
            var clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
            button.dispatchEvent(clickEvent);
        }, 150);
    }

    // ------------------------------------------------------------------
    // Status-Abfrage
    // ------------------------------------------------------------------

    function fetchStatus(params, done, fail) {
        $.ajax({
            url: config.ajaxUrl,
            type: 'POST',
            data: $.extend({ action: 'brandner_shipping_status', nonce: config.nonce }, params),
            success: function(response) {
                if (response && response.success) {
                    done(response.data);
                } else {
                    fail && fail();
                }
            },
            error: function() { fail && fail(); }
        });
    }

    function getProductIdFromButton(btn) {
        var card = btn.closest('.brandner-auction-card-bid, [data-product-id]');
        if (card) {
            return card.getAttribute('data-product-id') || card.dataset.productId;
        }
        return config.productId || null;
    }

    /**
     * Bid-Button-Klick abfangen (capturing). Laeuft NACH dem Terms-Interceptor:
     * blockiert der, kommt dieses Event gar nicht hier an (stopImmediatePropagation).
     */
    function interceptBidButton(e) {
        if (!config.loggedIn) return;
        var btn = e.target.closest(bidButtonSelectors);
        if (!btn) return;

        var $btn = $(btn);
        if ($btn.data('shipping-chosen')) {
            $btn.removeData('shipping-chosen');
            return;
        }

        var productId = getProductIdFromButton(btn);
        if (!productId) return;

        // Projekt bekannt und erledigt -> durchlassen
        var projectId = projectByProduct[productId];
        if (projectId !== undefined && statusByProject[projectId] === false) {
            return;
        }
        if (projectId === 0) {
            return; // kein Versandprojekt
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        pendingBidButton = btn;

        if (projectId && statusByProject[projectId] === true && dataByProject[projectId]) {
            openModal(dataByProject[projectId], true);
            return;
        }

        fetchStatus({ product_id: productId }, function(data) {
            if (!data.required) {
                projectByProduct[productId] = data.project_id || 0;
                if (data.project_id) statusByProject[data.project_id] = false;
                triggerOriginalBid(pendingBidButton);
                return;
            }
            projectByProduct[productId] = data.project_id;
            statusByProject[data.project_id] = true;
            dataByProject[data.project_id] = data;
            openModal(data, true);
        }, function() {
            // Netzwerkfehler: nicht blockieren, Server prueft ohnehin
            triggerOriginalBid(pendingBidButton);
        });

        return false;
    }

    /**
     * Alte "aendern"-Buttons (data-action) oeffnen das Modal direkt, ohne Gebot.
     */
    function bindChangeButtons() {
        $(document).on('click', '[data-action="brandner-shipping-change"]', function(e) {
            e.preventDefault();
            var projectId = $(this).data('project-id');
            if (!projectId) return;
            pendingBidButton = null;
            fetchStatus({ project_id: projectId }, function(data) {
                if (!data.project_id) return;
                dataByProject[projectId] = data;
                statusByProject[projectId] = data.required;
                openModal(data, false);
            });
        });
    }

    /**
     * Pre-Check auf der Losseite (Projekt bekannt).
     */
    function preCheck() {
        if (!config.productId || !config.loggedIn) return;
        if (config.active === false) {
            projectByProduct[config.productId] = 0;
            return;
        }
        fetchStatus({ product_id: config.productId }, function(data) {
            projectByProduct[config.productId] = data.project_id || 0;
            if (data.project_id) {
                statusByProject[data.project_id] = !!data.required;
                dataByProject[data.project_id] = data;
            }
        });
    }

    function init() {
        preCheck();
        bindChangeButtons();
        bindToggles();
        bindBidFallback();
        document.addEventListener('click', interceptBidButton, true);
    }

    $(document).ready(init);

})(jQuery);
